export default __webpack_public_path__ + "static/media/house1.d7d441d7.jpg";